// Firebase configuration
// Using compat API for FirebaseUI compatibility
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// Import root config file
// @ts-ignore - Root config file is outside src
import rootConfig from '@root/firebase.env.js';

// Get the selected environment and config
const currentEnv = rootConfig.environment;
const firebaseConfig = { ...rootConfig.config };

// Ensure authDomain matches the app domain to avoid cross-domain redirect issues
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;

  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    // Use the current staging/production host for authDomain
    firebaseConfig.authDomain = hostname;
  }
  // For localhost, keep the firebaseConfig.authDomain from your config (dev project)
}

// Log for debugging
console.log('[Admin Firebase Config]', {
  environment: currentEnv,
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  apiKey: firebaseConfig.apiKey?.substring(0, 20) + '...'
});

// Initialize Firebase (only if not already initialized)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Export auth instance
export const auth = firebase.auth();
export const db = firebase.firestore();
export { firebase };

export default firebase.app();
